export const BusinessSubscriptionPackage = {
  BRONZE: "bronze",
  SILVER: "silver",
  GOLD: "gold",
};
